module.exports = __webpack_public_path__ + "img/3_94.6eca3dc3.png";